/* backendStatus — tiny global signal for "is the backend reachable?".
 *
 * The axios response interceptor (lib/api.js) reports every request outcome
 * here. When the backend looks unreachable (network error / 5xx / Cloudflare
 * origin error) we flip to "down" so <BackendDownScreen/> can show a friendly
 * "We'll be right back" overlay. Any successful response flips us back to "up".
 *
 * We require a couple of consecutive failures before showing the screen so a
 * single transient blip doesn't flash the overlay; we hide on the FIRST
 * success so recovery feels instant.
 */
const listeners = new Set();
let down = false;
let consecutiveFailures = 0;
const FAIL_THRESHOLD = 2;

function emit() {
  for (const cb of listeners) cb(down);
}

export function subscribeBackendStatus(cb) {
  listeners.add(cb);
  cb(down);
  return () => listeners.delete(cb);
}

export function isBackendDown() {
  return down;
}

// Backend looks unreachable (no response, timeout, 5xx, CF 52x).
export function reportBackendDown() {
  consecutiveFailures += 1;
  if (consecutiveFailures >= FAIL_THRESHOLD && !down) {
    down = true;
    emit();
  }
}

// Got a real response from the backend — it's reachable again.
export function reportBackendUp() {
  consecutiveFailures = 0;
  if (down) {
    down = false;
    emit();
  }
}
